import './App.scss';
import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { MUIThemeConfiguration } from './globals/themes';
import Layout from './layout';
import Routes from './routes';
import SplashScreen from './components/SplashScreen';
import store from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import { ErrorBoundary } from 'react-error-boundary';
import ErrorPage from './pages/ErrorPage';

let persistor = persistStore(store);
const THEME = createTheme(MUIThemeConfiguration);

function App() {
	return (
		<ThemeProvider theme={THEME}>
			<CssBaseline />
			{/* Provide Redux store */}
			<Provider store={store}>
				{/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
				<PersistGate persistor={persistor}>
					<BrowserRouter>
						{/* Error Boundary */}
						<ErrorBoundary FallbackComponent={ErrorPage}>
							{/* Render routes with provided `Layout`. */}
							<Layout>
								{/* Routes */}
								<Routes />
							</Layout>
						</ErrorBoundary>
					</BrowserRouter>
				</PersistGate>
			</Provider>
		</ThemeProvider>
	);
}

export default App;
